import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    SwipeableRowActionWidthConstantType,
    SwipeableRowRadiusConstantType,
    SwipeableRowDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    concentric
} from "../../helpers/theme/concentric";
import {
    getCornerStyle
} from "../../helpers/theme/corner";
import {
    webStyle
} from "../../utils";

export const getSwipeableRowActionWidth = ({
    controlHeights,
    spaces
}: SwipeableRowActionWidthConstantType): number => {
    return controlHeights.large + spaces.spacingLg;
};

export const getSwipeableRowRadius = ({
    radiuses,
    borders,
    spaces
}: SwipeableRowRadiusConstantType): number => {
    return concentric({
        inset: spaces.spacingXs + borders.line,
        outer: radiuses.surface,
        isCapsuleExempt: false,
        role: radiuses.actions
    });
};

const stylesheet = StyleSheet.create({
    layer: {
        ...StyleSheet.absoluteFill,
        justifyContent: "space-between",
        pointerEvents: "box-none",
        flexDirection: "row"
    },
    trailingSide: {
        flexDirection: "row-reverse"
    },
    root: {
        minWidth: 0,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    metaHidden: {
        ...webStyle({
            visibility: "hidden"
        })
    },
    side: {
        alignItems: "stretch",
        flexDirection: "row",
        overflow: "hidden"
    },
    collapse: {
        overflow: "hidden"
    }
});

export const useStyles = ({
    isReserveEndEnabled,
    controlHeights,
    isSwipeEnabled,
    borderRadius,
    shapeConfigs,
    isRemoved,
    isClosed,
    colors,
    spaces
}: SwipeableRowDynamicStyleType) => {
    const styles = {
        root: {
            backgroundColor: colors.content.container.raised,
            overflow: isSwipeEnabled ? "hidden" : "visible",
            ...getCornerStyle({
                radius: borderRadius,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        container: {
            pointerEvents: isRemoved ? "none" : "auto"
        } as Mutable<ViewStyle>,
        actionsLayer: {
            display: isClosed ? "none" : "flex"
        } as Mutable<ViewStyle>
    };

    if(isReserveEndEnabled) {
        styles.root.paddingEnd = controlHeights.small + spaces.spacingSm * 2;
    }

    return styles;
};
export default stylesheet;
